import React, { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { logAdmin } from '../utils/adminDebug';
import { useLanguage } from '../hooks/useLanguage';
import { ContentPageLayout } from '../components/Shared';

const AdminHomepage: React.FC = () => {
  const { t } = useTranslation();
  const { navigateWithLang } = useLanguage();

  useEffect(() => {
    logAdmin('AdminHomepage mounted');
  }, []);

  return (
    <ContentPageLayout>
    <Box>
      <Typography variant="h5" component="h1" gutterBottom color="primary" sx={{ fontWeight: 'bold' }}>
        {t('dashboard.title')}
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        {t('dashboard.subtitle')}
      </Typography>
      <Box display="flex" flexWrap="wrap" gap={1} mt={2}>
        <Button variant="outlined" onClick={() => navigateWithLang('/dashboard')}>
          {t('sidebar.dashboard')}
        </Button>
        <Button variant="outlined" onClick={() => navigateWithLang('/users')}>
          {t('sidebar.users')}
        </Button>
        <Button variant="outlined" onClick={() => navigateWithLang('/sessions')}>
          {t('sidebar.sessions')}
        </Button>
        <Button variant="outlined" onClick={() => navigateWithLang('/progression')}>
          {t('sidebar.progression')}
        </Button>
        <Button variant="outlined" onClick={() => navigateWithLang('/files')}>
          {t('sidebar.files')}
        </Button>
        <Button variant="outlined" onClick={() => navigateWithLang('/exercises')}>
          {t('sidebar.exercises')}
        </Button>
        <Button variant="outlined" onClick={() => navigateWithLang('/playbacks')}>
          {t('sidebar.playbacks')}
        </Button>
        <Button variant="outlined" onClick={() => navigateWithLang('/page-editor')}>
          {t('sidebar.pageEditor')}
        </Button>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        {t('dashboard.hint')}
      </Typography>
    </Box>
    </ContentPageLayout>
  );
};

export default AdminHomepage;
